module.exports = __webpack_public_path__ + "img/item_link_engraving.7a80b31.jpg";